import { useCallback, useState } from "react";
import { Toaster } from "sonner";
import "@/App.css";
import { useSmoothScroll } from "@/hooks/useSmoothScroll";
import { Cursor } from "@/components/Cursor";
import { TitleSequence } from "@/components/TitleSequence";
import { Nav } from "@/components/Nav";
import { PersistentCTA } from "@/components/PersistentCTA";
import { BriefModal } from "@/components/BriefModal";
import { Hero } from "@/components/Hero";
import { Showreel } from "@/components/Showreel";
import { WhyHire } from "@/components/WhyHire";
import { SelectedWork } from "@/components/SelectedWork";
import { PosterExhibition } from "@/components/PosterExhibition";
import { ProjectModal } from "@/components/ProjectModal";
import { Commercial } from "@/components/Commercial";
import { Creators } from "@/components/Creators";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Process } from "@/components/Process";
import { SpeedPipeline } from "@/components/SpeedPipeline";
import { AIWorkflow } from "@/components/AIWorkflow";
import { Toolkit } from "@/components/Toolkit";
import { About } from "@/components/About";
import { Footer } from "@/components/Footer";

const MARQUEE_ITEMS = [
  "SHORT-FORM",
  "PODCAST CUTS",
  "MOTION DESIGN",
  "PRODUCT REVEALS",
  "EVENT PROMOS",
  "STREAM HIGHLIGHTS",
];

const TOAST_OPTIONS = {
  style: {
    background: "#111111",
    border: "1px solid #262626",
    color: "#e5e5e5",
    borderRadius: 0,
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: 12,
    letterSpacing: "0.06em",
  },
};

function App() {
  useSmoothScroll();
  const [brief, setBrief] = useState(false);
  const [project, setProject] = useState(null);

  const openBrief = useCallback(() => setBrief(true), []);
  const closeBrief = useCallback(() => setBrief(false), []);

  return (
    <div className="grain relative min-h-screen bg-[#0a0a0a]">
      <Cursor />
      <TitleSequence />
      <Nav onBrief={openBrief} />
      <PersistentCTA onClick={openBrief} />

      <main>
        <Hero onBrief={openBrief} />
        <Showreel onBrief={openBrief} />
        <WhyHire />
        <SelectedWork onOpen={setProject} />
        <PosterExhibition />
        <Services />
        <Commercial onOpen={setProject} />
        <Creators />
        <Marquee items={MARQUEE_ITEMS} />
        <Process />
        <SpeedPipeline />
        <AIWorkflow />
        <Toolkit />
        <About />
        <Footer onBrief={openBrief} />
      </main>

      <ProjectModal
        project={project}
        onClose={() => setProject(null)}
        onBrief={openBrief}
      />
      <BriefModal open={brief} onClose={closeBrief} />
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={TOAST_OPTIONS}
      />
    </div>
  );
}

export default App;
